import { memo, useRef } from 'react'
import { Container, Text } from '@pixi/react'
import { Button, soundManager, t, useVoucherStore } from '@slot-nx/core'
import { Text as PixiText } from 'pixi.js'
import { playNowBtnTextStyle } from '../selectPopup/VoucherSelectPopupButtons'
import { MachineActionType, sweetBombMachine } from '../../../../machine/sweetbombMachine'
import { VoucherSoundType } from '../../../domain/soundManager/enum/VoucherSoundType'

export const VoucherTotalWinButton = memo(() => {
  const continueTextRef = useRef<PixiText>()
  const [currentVoucherId, tempSlotVoucher] = useVoucherStore(x => [x.currentVoucherId, x.tempSlotVoucher])
  return (

    <Container name="VoucherTotalWinButton">
      <Button
        name="continue_btn"
        defaultView="voucher_play_now_normal"
        hoverView="voucher_play_now_hover"
        pressedView="voucher_play_now_click"
        disabledView="voucher_play_now_disabled"
        enabled={true}
        x={-170.5}
        y={240}
        width={341}
        height={157}
        key="continue_btn"
        onPressing={() => {
          (continueTextRef.current as PixiText).position.y = 312
        }}
        onHoverEnd={() => {
          (continueTextRef.current as PixiText).position.y = 305
        }}
        onPress={() => {
          soundManager.play(VoucherSoundType.buttonClick)
          if (tempSlotVoucher !== null && tempSlotVoucher.voucherId !== currentVoucherId) {
            sweetBombMachine.send({ type: MachineActionType.voucherTimeStart })
          }
          else {
            sweetBombMachine.send({ type: MachineActionType.voucherBackToMainGame })
          }
          useVoucherStore.setState({ isShowVoucherTotalWinPopup: false })
        }}
      />
      <Text
        text={t('voucher_total_win_popup_continue_btn')}
        x={0}
        y={305}
        anchor={[0.5, 0.5]}
        name="CONTINUE"
        style={playNowBtnTextStyle}
        ref={(el) => {
          continueTextRef.current = el as PixiText
        }}
      />

    </Container>

  )
})
